import { isEmpty } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { COMPARE_FILTER_TYPE } from "../../utils/constants";
import {
    getReactSelectStyling,
    getReactSelectTheme,
} from "../../utils/ReactSelectStyles";

const CompareFilter = ({
    field,
    input,
    handleTargetChange,
    handleCompareChange,
    handleValueChange,
}) => {
    const { t } = useTranslation();

    const compareOptions = [
        {
            label: t(COMPARE_FILTER_TYPE.lessThan),
            value: COMPARE_FILTER_TYPE.lessThan,
        },
        {
            label: t(COMPARE_FILTER_TYPE.equals),
            value: COMPARE_FILTER_TYPE.equals,
        },
        {
            label: t(COMPARE_FILTER_TYPE.greaterThan),
            value: COMPARE_FILTER_TYPE.greaterThan,
        },
        {
            label: t(COMPARE_FILTER_TYPE.greaterThanOrEqual),
            value: COMPARE_FILTER_TYPE.greaterThanOrEqual,
        },
        {
            label: t(COMPARE_FILTER_TYPE.lessThanOrEqual),
            value: COMPARE_FILTER_TYPE.lessThanOrEqual,
        },
    ];

    const valueDisabled = () => isEmpty(input.target) || isEmpty(input.compare);

    return (
        <div className="flex gap-2">
            <Select
                name="target"
                options={field.options}
                placeholder={field.targetPlaceholder}
                isDisabled={field.options?.length == 0}
                isClearable={true}
                onChange={handleTargetChange}
                value={
                    field.options.find(
                        (opt) =>
                            opt.value.toLowerCase() ===
                            input?.target.toLowerCase()
                    ) || ""
                }
                theme={getReactSelectTheme}
                styles={getReactSelectStyling()}
                className="w-35"
                isLoading={field.isLoading}
            />
            <Select
                name="compare"
                options={compareOptions}
                placeholder={t("comparePlaceholder")}
                isClearable={true}
                isDisabled={field.options.length === 0}
                onChange={handleCompareChange}
                value={
                    compareOptions.find(
                        (opt) => opt.value === input?.compare
                    ) || ""
                }
                theme={getReactSelectTheme}
                styles={getReactSelectStyling()}
                className="w-35"
            />
            <input
                type="number"
                className={`input-element small-width flex-1 ${
                    valueDisabled() ? "disabled" : ""
                }`}
                placeholder={field.placeholder}
                disabled={valueDisabled()}
                name={field.name}
                onWheel={(e) => e.target.blur()}
                onChange={handleValueChange}
                value={input?.value}
            />
        </div>
    );
};

export default CompareFilter;
